module.exports = __webpack_public_path__ + "img/FarbenDesRegenbogens.ecbec09d.jpg";